import React from "react"

import Tooltip from "@mui/material/Tooltip"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const tooltip = (text) => {
    return (
        <Tooltip title={text} sx={{ m: 1 }}>
            <InfoOutlinedIcon sx={{ ml: 0.5, fontSize: 14, color: "green" }} />
        </Tooltip>
    )
}

export const generalTooltipText = {
    differentiationValue: "A positive value driver is when you generate more value than your competitive alternative, while a negative value driver is the opposite.",
    revenueModel: (
        <>
          A revenue model is the framework a business uses to generate income from its products or services. It outlines how revenue is earned, whether through recurring fees or one-time transactions.
          <br /><br />
          <strong>Subscription-Based Revenue Model:</strong>
          <br />
          Customers pay a recurring fee (e.g., monthly or annually) to access a service or product, providing predictable, steady revenue and fostering ongoing customer relationships.
          <br /><br />
          <strong>Transactional Revenue Model:</strong>
          <br />
          Revenue is generated on a per-transaction basis, meaning customers pay each time they make a purchase or use the service, without a recurring commitment.
        </>
      ),
      acv: "Annual Contract Value (ACV) is the total revenue expected from a contract over one year. It reflects the recurring revenue generated from each customer agreement.",
      contributionMargin: "Contribution margin is the difference between sales revenue and variable costs, indicating the amount available to cover fixed costs and contribute to profit.",
      transactionValue: "Transaction value (average) represents the monetary amount generated from a single sale or transaction.",
      transactionFrequency: "Annual transaction frequency (average) represents the number of transactions occurring within a year",
}